<menu></menu>
<div id="container">
    <div class="form">
        <div class="header" table=true style="--cs:1fr 50px">
            <span>Listagem de Solicitantes</span>
            <mat-icon (click)="edit(null)" *ngIf="util.isMaster()">note_add</mat-icon>
        </div>
        <div class="struct" id="struct">
            <buscasolicitante *ngIf="!loading" [data]="solicitantes" (sign)="edit($event)"></buscasolicitante>
        </div>
    </div>
</div>
<spinner *ngIf="loading"></spinner>